module.exports = __webpack_public_path__ + "assets/img/settlebgNew.408bcd2f.png";